<template lang="pug">
  v-dialog(v-model="dialog" persistent width="500" @keydown.esc="closeDialog")
    v-card
      v-toolbar(dark :color="$store.getters['site/siteColor']")
        v-icon(left color="white darken-2" large) help
        span  {{ title }}
        v-spacer
        v-btn(flat icon @click="closeDialog")
          v-icon close

      v-card-text
        v-layout
          v-flex
            div(class="ma-3") {{ message }}

      v-toolbar.footer
        v-spacer
        v-btn(color="primary" @click="yes") 作成する
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "日跨ぎ仮カード作成確認"
    },
    message: {
      type: String,
      required: false,
      default: "日跨ぎカードの次運行（翌日分）に仮カードを作成しますか？"
    }
  },
  data() {
    return {
      dialog: false,
      text: null,
      params: {}
    };
  },
  methods: {
    openDialog(item) {
      this.params = item;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    yes() {
      this.$emit("yes");
      this.$store
        .dispatch("dispatch/createDayExceedTemp", this.params)
        .then(() => {})
        .catch(reason => {
          this.$emit("error", reason.message);
          this.closeDialog();
        })
        .finally(() => this.closeDialog());
    }
  }
};
</script>
